/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */

import * as firebase from 'firebase/app';

const firebaseConfig = {
    'apiKey': 'AIzaSyBvJUEA9pVySobJ8Q5pj8KhBzgjDjH6PGI',
    'authDomain': 'picol-lig.firebaseapp.com',
    'databaseURL': 'https://picol-lig.firebaseio.com',
    'projectId': 'picol-lig',
    'storageBucket': 'picol-lig.appspot.com',
    'messagingSenderId': '702340079931',
    'appId': '1:702340079931:web:5c73b5fc7026b553c1571e',
};
export default firebase.initializeApp(firebaseConfig);